<template lang="pug">
    v-menu( offset-y)
      v-btn(icon slot="activator" data-cy="contact-comunication-actions")
        v-icon more_vert
      v-list.contact-actions 
        v-list-tile(
          v-if="!isCallDisabled"
          @click="handleMakeCall()" 
          data-cy="call-contact"
        )
          v-list-tile-title
            span 
              v-icon call
              |&nbsp; Call Contact
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async handleMakeCall() {
      if (!this.callPayload.phone) {
        this.setTasksErrorManual({ code: '', message: 'There is no mobile phone number for this contact', isError: true });
        return;
      }
      this.makeCall(this.callPayload);
    },
    ...mapActions('contact', ['makeCall']),
    ...mapActions('tasks', ['setTasksErrorManual']),
  },
  computed: {
    ...mapState({ user: state => state.userInformation.user }),
    callPayload() {
      return {
        contactId: this.contact.contact_id,
        phone: this.contact.contact_mobile_phone,
        agentName: `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim(),
        type: 'Mobile phone',
      };
    },
    isCallDisabled() {
      return this.user && 
              this.user.subscriptionOverview && 
              this.user.subscriptionOverview.txt_status === 'trial';
    },
  },
};
</script>